import React from 'react';
import styled from 'styled-components';

const ControllsAreaContainer = styled.div`
    padding-bottom: 20px;
`;

const ControllsArea: React.FC = ({ children }) => <ControllsAreaContainer>{children}</ControllsAreaContainer>;

export default ControllsArea;
